export default "__VITE_ASSET__820a61ec__"